<template>
	<div id="schoolroll">
		<lead />
		<main class="main">
			<router-view />
		</main>
		<foote />
	</div>
</template>

<script>
	import lead from './head';
	import foote from '@/components/common/footer';
	export default{
		components: {
			lead,foote,
		}
	}
</script>
<style lang="scss">
	.main{
		min-height: calc(100vh - 164px);
		padding: 25px 0 0;
		button{
			border-width:0;
		}
		.pointer{
			cursor:pointer;
		}
	}
</style>